import { clamp } from 'lodash';

export interface Point {
  x: number;
  y: number;
}

const regionOverlayRatio = 4 / 3;

export function pointsToPolygonString(points: Point[]): string {
  return points
    .map((p) => {
      const x = clamp(p.x, 0, 1);
      const y = clamp(p.y, 0, 1);
      return `${x} ${y}`;
    })
    .join(', ');
}

export function polygonStringToPoints(polygon: string): Point[] {
  return polygon.split(', ').map((segment) => {
    const [xs, ys] = segment.split(' ');
    const x = clamp(parseFloat(xs), 0, 1);
    const y = clamp(parseFloat(ys), 0, 1);
    return { x, y };
  });
}

export function convertPixelPointToNormalizedPoint(pixelPoint: Point, imageWidth: number, imageHeight: number): Point {
  let { x, y } = pixelPoint;
  const aspect = imageWidth / imageHeight;

  if (aspect > regionOverlayRatio) {
    const ratio = regionOverlayRatio / aspect;
    y = y * ratio + imageHeight * ((1 - ratio) / 2);
  } else {
    const ratio = aspect / regionOverlayRatio;
    x = x * ratio + imageWidth * ((1 - ratio) / 2);
  }

  return {
    x: clamp(x / imageWidth, 0, 1),
    y: clamp(y / imageHeight, 0, 1),
  };
}

export function convertNormalizedPointToPixelPoint(
  normalizedPoint: Point,
  imageWidth: number,
  imageHeight: number
): Point {
  let { x, y } = normalizedPoint;
  const aspect = imageWidth / imageHeight;

  if (aspect > regionOverlayRatio) {
    const ratio = regionOverlayRatio / aspect;
    y = (y * imageHeight) / ratio - (imageHeight / ratio) * ((1 - ratio) / 2);
    x *= imageWidth;
  } else {
    const ratio = aspect / regionOverlayRatio;
    x = (x * imageWidth) / ratio - (imageWidth / ratio) * ((1 - ratio) / 2);
    y *= imageHeight;
  }

  return { x, y };
}
